export const MANAGER_NAV_SECTIONS = [
  {
    title: "Orders & Bookings",
    items: [
      { key: "shop-orders", label: "Product Orders", icon: "📦" },
      { key: "print-orders", label: "Print Orders", icon: "📄" },
      { key: "studio-bookings", label: "Studio Bookings", icon: "📅" },
      { key: "wedding-bookings", label: "Wedding Bookings", icon: "📅" },
      { key: "event-bookings", label: "General Event Bookings", icon: "📅" },
      { key: "studio-rental-bookings", label: "Rental Bookings", icon: "📅" },
      { key: "completed-shop-orders", label: "Completed Orders", icon: "✅" },
      { key: "customers", label: "Customers", icon: "👥" },
    ],
  },
  {
    title: "Services & Shop",
    items: [
      { key: "studio-packages", label: "Studio Packages", icon: "📸" },
      { key: "wedding-packages", label: "Wedding Packages", icon: "💍" },
      { key: "event-packages", label: "General Event Packages", icon: "🎉" },
      { key: "studio-rentals", label: "Studio Rentals", icon: "🏢" },
      { key: "prints", label: "Print Items", icon: "🖨️" },
      { key: "print-categories", label: "Print Categories", icon: "🏷️" },
      { key: "shop-products", label: "Shop Items", icon: "🛒" },
      { key: "shop-categories", label: "Shop Categories", icon: "📂" },
    ],
  },
  {
    title: "Feedback",
    items: [
      { key: "reviews", label: "Customer Reviews", icon: "⭐" },
    ],
  },
];

// Flat list for easy reference/routing if needed elsewhere
export const MANAGER_NAV_ITEMS = MANAGER_NAV_SECTIONS.flatMap(s => s.items);
